import { createStructuredSelector } from 'reselect';
import {
  ownerCreateModalOpenSelector,
  ownerSelector,
} from '../../selectors/owner';

export default createStructuredSelector({
  modalOpen: ownerCreateModalOpenSelector,
  createdOwner: ownerSelector,
});
